import React from "react";
import cn from "classnames";
import "./AppLabel.scss";
import "../AppInput/AppInput.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";

export type AppLabelProps = {
  label: string;
  labelFor?: string;
  id?: string;
  required?: true | false;
  toolTipText?: string;
  disabled?: true | false;
  style?: React.CSSProperties;
};

export const AppLabel: React.FC<AppLabelProps> = ({
  label,
  id,
  labelFor,
  required,
  toolTipText,
  disabled = false,
  style,
}) => {
  return (
    <div className={cn("AppInput", disabled ? "label-disabled" : "")}>
      {label && (
        <label className={cn("label")} htmlFor={labelFor} style={style}>
          {label}
          {required && <span className={cn("label-required")}>*</span>}
        </label>
      )}
      {toolTipText && (
        <div className="tooltip">
          <FontAwesomeIcon icon={faCircleInfo} />
          <span className="tooltiptext">{toolTipText}</span>
        </div>
      )}
    </div>
  );
};
export default AppLabel;
